if (!customElements.get('count-down')) {
  class CountDown extends HTMLElement {
    constructor() {
      super();
      // Slots
      this.days  = this.querySelector('.days');
      this.hours = this.querySelector('.hours');
      this.min   = this.querySelector('.min');
      this.sec   = this.querySelector('.sec');
      this.countDown = this.querySelector('.countdown');
      this.finishCountDown = this.querySelector('.finish-countdown');

      this.interval = null;
      this.target = this.parseTargetDate(this.dataset.countdown);
    }

    static get observedAttributes() {
      return ['data-date'];
    }

    attributeChangedCallback(name, oldVal, newVal) {
      if (name === 'data-date' && oldVal !== newVal) {
        this.target = this.parseTargetDate(newVal);
        this.restart();
      }
    }

    connectedCallback() {
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    parseTargetDate(str) {
      if (!str) return null;
      const parts = String(str).trim().split('-');
      if (parts.length !== 3) return null;

      let [dd, mm, yyyy] = parts.map(n => parseInt(n, 10));
      if (Number.isNaN(dd) || Number.isNaN(mm) || Number.isNaN(yyyy)) return null;

      const d = new Date(yyyy, mm - 1, dd, 23, 59, 59, 999);
      if (d.getFullYear() !== yyyy || d.getMonth() !== mm - 1 || d.getDate() !== dd) {
        return null;
      }
      return d;
    }

    start() {
      this.updateDisplay();

      this.stop();
      this.interval = setInterval(() => {
        this.updateDisplay();
      }, 1000);
    }

    stop() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }

    restart() {
      this.stop();
      this.start();
    }

    updateDisplay() {
      if (!this.target) {
        this.renderValues(0, 0, 0, 0);
        this.swapToFinished(true);
        return;
      }

      const now = new Date();
      let diffMs = this.target - now;
      if (diffMs <= 0) {
        this.renderValues(0, 0, 0, 0);
        this.swapToFinished(true);
        this.stop();
        return;
      }

      const totalSeconds = Math.floor(diffMs / 1000);
      const days  = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const mins  = Math.floor((totalSeconds % 3600) / 60);
      const secs  = totalSeconds % 60;

      this.renderValues(days, hours, mins, secs);
      this.swapToFinished(false);
    }

    renderValues(d, h, m, s) {
      const pad2 = (n) => String(n).padStart(2, '0');

      if (this.days)  this.days.textContent  = String(d).padStart(2, '0');
      if (this.hours) this.hours.textContent = pad2(h);
      if (this.min)   this.min.textContent   = pad2(m);
      if (this.sec)   this.sec.textContent   = pad2(s);
    }

    swapToFinished(finished) {
      if (this.countDown) this.countDown.classList.toggle('!hidden', finished);
      if (this.finishCountDown) this.finishCountDown.classList.toggle('hidden', !finished);
    }
  }

  customElements.define('count-down', CountDown);
}
